<template>
    <v-container>

        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            :return-value.sync="date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <v-text-field
                                slot="activator"
                                v-model="audit.start"
                                label="Fecha inicio"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                        <v-date-picker v-model="audit.start"
                                       @input="$refs.menu.save(audit.start)"></v-date-picker>
                    </v-menu>
                    <v-menu
                            ref="menu2"
                            :close-on-content-click="false"
                            v-model="menu2"
                            :nudge-right="40"
                            :return-value.sync="date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <v-text-field
                                slot="activator"
                                v-model="audit.end"
                                label="Fecha fin"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                        <v-date-picker v-model="audit.end"
                                       @input="$refs.menu2.save(audit.end)"></v-date-picker>
                    </v-menu>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-select
                                    v-model="audit.user"
                                    :items="$store.state.users"
                                    item-text="completeName"
                                    item-value="id"
                                    :rules="[v => !!v || 'La asignación del doctor es requerido']"
                                    label="Usuario"
                                    return-object
                                    persistent-hint
                                    required
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-btn :disabled="!valid"
                   @click="seachData" large color="primary">Buscar</v-btn>
        </v-form>

        <h3 class="primary--text">Auditoría</h3>
        <v-data-table
                :headers="headers"
                :items="auditRecords"
                class="elevation-1"
                :search="search"
                :pagination.sync="pagination"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left">{{ props.item.action }}</td>
                <td class="text-xs-left">{{ props.item.screen }}</td>
                <td class="text-xs-left">{{ props.item.user.login }}</td>
                <td class="text-xs-left">
                    <span v-if="props.item.codigoPaciente == null"> {{ props.item.identificacionPaciente }} </span>
                    <a @click="redirectToPatient(props.item)" v-if="props.item.codigoPaciente !== null"> {{ props.item.codigoPaciente }} </a>
                </td>        
                <td class="text-xs-left">{{ props.item.nombresPaciente }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>

    import Role from "../../model/Role";
    import Patient from "../patient/Patient";

    export default {
        data() {
            return {
                search: '',
                pagination: {
                    sortBy: 'date',
                    descending: true
                },
                headers: [
                    {text: 'Fecha', value: 'date'},
                    {text: 'Acción', value: 'action'},
                    {text: 'Pantalla', value: 'screen'},
                    {text: 'Usuario', value: 'user'},
                    {text: 'Id. Paciente', value: 'identificacionPaciente'},
                    {text: 'Nombres paciente', value: 'nombresPaciente'}
                ],
                auditRecords: [],
                audit: {
                    start: "",
                    end: "",
                    user: null
                },
                menu: false,
                menu2: false,
                valid: false,
                date: new Date().toISOString().substr(0, 10),                
            };
        }, methods: {
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
            seachData(){
                this.auditRecords=[]
                if(this.audit.user!=null){
                    this.audit.user.company = null
                }                
                this.$store.dispatch('getAuditRecordsDateBetween',this.audit).then(response => {
                  this.auditRecords.push(...response.data);
                }, error => {
                  this.$store.state.dialogError = true
                })
            },
            redirectToPatient(item) {                                
                this.$store.state.buscadorPaciente = item.identificacionPaciente;                
                const patient = 
                    {
                        path: "/patient",
                        component: Patient
                    };
                this.$router.push(patient);
            }
        },
        computed: {},
        beforeCreate() {
            this.$store.dispatch('getUsers').then(response => {
            })
            // this.$store.dispatch('getAuditRecords').then(response => {
            //   this.auditRecords.push(...response.data);
            // }, error => {
            //   this.$store.state.dialogError = true
            // })
        },
        components: {
            Patient
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/audit/Audit.vue